import axios from "axios";
import { headerConfig } from "../utility/RequestHeaderConfig";
import { BASE_API_URL } from "../utility/URL";





const save = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "coach/action", data, headerConfig);
        return response.data;
  };


const list = async () => {
    const response = await axios
        .post(BASE_API_URL + "coach/list", {}, headerConfig);
        return response;
};



const ratioList = async () => {
    const response = await axios
        .post(BASE_API_URL + "coach/ratio-list", {}, headerConfig);
        return response;
};

const designationList = async () => {
    const response = await axios
        .post(BASE_API_URL + "coach/designation-list", {}, headerConfig);
        return response;
};



const coachService = {
    save,
    list,
    ratioList,
    designationList
    
};

export default coachService;